module.exports = __webpack_public_path__ + "media/svg-new/lock-67b38bd2.svg";